export const CONTACT = {
  phone: "+351 936 225 295",
  phoneHref: "tel:+351936225295",
  whatsapp: "https://wa.me/351936225295?text=" + encodeURIComponent("Olá DOG'Z! Gostaria de pedir informações."),
  instagram: "https://instagram.com/dogz.training_hotel",
  instagramHandle: "@dogz.training_hotel",
  instagramBanhos: "https://instagram.com/dogz.banhos_tosquias",
  instagramBanhosHandle: "@dogz.banhos_tosquias",
  address: "Rua da Poça, Palmeira, Braga",
  mapEmbed: "https://www.google.com/maps?q=" + encodeURIComponent("Rua da Poça, Palmeira, Braga, Portugal") + "&output=embed",
  mapLink: "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Rua da Poça, Palmeira, Braga"),
};

export const SERVICES = [
  {
    slug: "hotel-canino",
    name: "Hotel Canino",
    index: "01",
    lines: ["Hotel", "Canino"],
    kicker: "Alojamento · Estadias curtas e longas",
    hero: "/img/real-hotel-spaniel.jpg",
    heroPos: "50% 52%",
    short: "Estadias tranquilas com rotina, passeios e muito acompanhamento enquanto está fora.",
    intro:
      "Quando viaja, o seu cão fica em casa — só que noutra casa. No Hotel DOG'Z cada hóspede tem o seu espaço, uma rotina pensada à sua medida e uma equipa que o conhece pelo nome.",
    features: [
      { t: "Espaço individual", d: "Boxes confortáveis e limpas, com cama, água fresca e descanso sem stress." },
      { t: "Rotina diária", d: "Horários de refeição, passeios e brincadeira respeitados todos os dias." },
      { t: "Atualizações", d: "Fotografias e notícias do seu cão diretamente no WhatsApp." },
      { t: "Atenção individual", d: "Medicação, alimentação própria e necessidades especiais tratadas com rigor." },
    ],
    gallery: [{ src: "/img/hotel-h3.jpg", pos: "50% 50%" }, { src: "/img/hotel-h2.jpg", pos: "50% 48%" }, { src: "/img/hotel-h1.jpg", pos: "50% 16%" }],
  },
  {
    slug: "creche-canina",
    name: "Creche Canina",
    index: "02",
    lines: ["Creche", "Canina"],
    kicker: "Dia a dia · Socialização",
    hero: "/img/real-creche-abraco.jpg",
    card: "/img/real-creche-piscina.jpg",
    heroPos: "50% 62%",
    short: "Dias cheios de energia gasta da forma certa: socialização, jogo e descanso.",
    intro:
      "A creche é o dia perfeito para cães que não gostam de ficar sozinhos. Brincadeira supervisionada, estímulo mental e pausas de descanso — e ao fim do dia, um cão feliz e cansado.",
    features: [
      { t: "Socialização supervisionada", d: "Grupos formados por tamanho, idade e temperamento." },
      { t: "Estímulo mental", d: "Jogos de faro, desafios e pequenos exercícios de obediência." },
      { t: "Atividade física", d: "Tempo ao ar livre para correr, explorar e gastar energia." },
      { t: "Descanso programado", d: "Pausas tranquilas para recuperar entre atividades." },
    ],
    gallery: [
      { src: "/img/creche-c2.jpg", pos: "50% 72%" },
      { src: "/img/creche-c5.jpg", pos: "50% 55%" },
      { src: "/img/creche-c4.jpg", pos: "50% 52%" },
      { src: "/img/creche-c3.jpg", pos: "50% 42%" },
      { src: "/img/creche-c1.jpg", pos: "50% 58%" },
    ],
  },
  {
    slug: "treinos",
    name: "Treinos",
    index: "03",
    lines: ["Treino", "de Cães"],
    kicker: "Obediência · Comportamento",
    hero: "/img/real-treinador.jpg",
    heroPos: "50% 12%",
    short: "Obediência, comportamento e foco — com métodos claros e consistentes.",
    intro:
      "Um cão equilibrado é um cão mais livre. Trabalhamos a obediência, a comunicação e o comportamento com planos à medida de cada cão e de cada família.",
    features: [
      { t: "Obediência básica", d: "Sentar, deitar, ficar, chamada e passeio à trela sem puxões." },
      { t: "Obediência avançada", d: "Controlo à distância, foco e trabalho com distrações." },
      { t: "Problemas de comportamento", d: "Reatividade, ansiedade, destruição e outros desafios do dia a dia." },
      { t: "Aulas para tutores", d: "Ensinamos a família a manter os resultados em casa." },
    ],
    gallery: ["/img/treino-pequenos.jpg", { src: "/img/treino-pastor.jpg", pos: "50% 22%" }, { src: "/img/treino-collie.jpg", pos: "50% 50%" }],
  },
  {
    slug: "criacao-pastor-alemao",
    name: "Criação de Pastor Alemão",
    index: "04",
    lines: ["Pastor", "Alemão"],
    kicker: "Criação · Ninhadas selecionadas",
    hero: "/img/gsd-p1.jpg",
    heroPos: "50% 46%",
    short: "Criação dedicada de Pastor Alemão, com foco em saúde, carácter e equilíbrio.",
    intro:
      "O Pastor Alemão é a raça que nos define. Criamos com paixão e responsabilidade, acompanhando cada ninhada desde o primeiro dia e ajudando cada família a escolher o cachorro certo.",
    features: [
      { t: "Progenitores selecionados", d: "Escolhidos pelo temperamento, estrutura e saúde." },
      { t: "Socialização precoce", d: "Cachorros habituados a pessoas, sons e novos estímulos." },
      { t: "Acompanhamento", d: "Apoio à família antes e depois da adoção do cachorro." },
      { t: "Ninhadas disponíveis", d: "Contacte-nos para saber as próximas ninhadas e reservas." },
    ],
    gallery: ["/img/gsd-pups-tiles.jpg", "/img/gsd-pups-fire.jpg", "/img/gsd-p2.jpg"],
  },
  {
    slug: "banhos-tosquias",
    name: "Banhos & Tosquias",
    index: "05",
    lines: ["Banhos &", "Tosquias"],
    kicker: "Estética · Higiene · Bem-estar",
    hero: "/img/banho-2.jpg",
    heroPos: "50% 40%",
    short: "Banho, tosquia e cuidados de higiene com calma, paciência e produtos de qualidade.",
    intro:
      "Um banho bem feito é mais do que estética: é saúde e conforto. Tratamos cada cão com tempo e cuidado, para que saia limpo, leve e tranquilo.",
    features: [
      { t: "Banho completo", d: "Lavagem, secagem e escovagem adaptadas ao tipo de pelo." },
      { t: "Tosquia", d: "Corte higiénico ou completo, de acordo com a raça e a estação." },
      { t: "Unhas e ouvidos", d: "Corte de unhas e limpeza de ouvidos com cuidado." },
      { t: "Remoção de sub-pelo", d: "Escovagem profunda para raças de pelo duplo." },
    ],
    gallery: [{ src: "/img/banho-4.jpg", pos: "50% 45%" }, { src: "/img/banho-3.jpg", pos: "50% 30%" }, { src: "/img/banho-1.jpg", pos: "50% 35%" }],
  },
];

export const SERVICE_OPTIONS = [
  ...SERVICES.map((s) => ({ value: s.slug, label: s.name })),
  { value: "outro", label: "Outro assunto" },
];
